import { useReducer } from 'react';

const useGlobalFromData = () => {

const initialState={
    errorMessage:{},
    taxList:{}
}




function customMiddleware(reducer) {
    return function(state, action) {

      return reducer(state, action);
    };
  }


const updateReducer=(state, action)=>{
    const {value={},name="",type=""}=action?.payload||{};

    switch (action.type) {
        case "load_data_api":
            return { ...state , ...action?.payload};
        case "ser_errors":
            return { ...state , errorMessage:action?.payload};
            case "input_file":
                return { ...state , [name]:{
                    name: action?.payload?.files[0].name,
                    url: URL.createObjectURL(action?.payload?.files[0]),
                    file: action?.payload?.files[0],
                  }};
        
                  case "input":
                    return { ...state ,errorMessage:{}, [name]: type=="checkbox" ? action.payload.checked ?  true:false :  value};
            default: return state
    
       
    }
}

const [stateData,dispatch] =useReducer(customMiddleware(updateReducer),initialState)


  return{stateData,dispatch}
}

export default useGlobalFromData